export enum PaymentType {
    Card = 'card',
    Cash = 'cash',
    Paypal = 'paypal',
    Stripe = 'stripe',
    Account = 'account',
}